import { configContentHub } from "@pub/config";
import placeholders from "@pub/placeholders";
import { Arrow, VideoGalleryLandscape } from "@sphtech/dmg-design-system";
import { ContentHubData } from "@src/app/types/ServerCustomContext";
import cx from "classnames";
import { ReactNode } from "react";

import styles from "../contenthub.module.css";

type Props = {
  data?: Omit<ContentHubData, "metaData">;
};

export default function ContentHubVideoGalleryLandscape({
  data,
}: Props): ReactNode {
  const ContentVideoBlock = data?.videoPlaylist;
  if (!ContentVideoBlock?.videoTeaser?.length) return null;

  return (
    <div
      className={cx(
        styles.backgroundFill,
        styles.videoGalleryLandscapeContainer,
        styles.videoGalleryColorOverride,
      )}
    >
      <div className={styles.bodyContainer}>
        <VideoGalleryLandscape
          title={
            (configContentHub.videoGalleryLandscape?.heading?.title &&
              ContentVideoBlock.heading) ||
            ""
          }
          items={ContentVideoBlock.videoTeaser.map((item) => {
            const crop = item.image?.crops.landscape || placeholders.landscape;
            return {
              ...crop,
              videoUrl: item.embedUri,
              sections: item.sections,
              caption: item.title,
              captionUrl: item.path,
              description: configContentHub.videoGalleryLandscape
                ?.hasItemDescription
                ? item.description
                : undefined,
            };
          })}
          heading={{
            leftIcon: configContentHub.videoGalleryLandscape?.heading?.leftIcon,
            rightIcon:
              configContentHub.videoGalleryLandscape?.heading?.rightIcon,
            withDivider:
              configContentHub.videoGalleryLandscape?.heading?.withDivider,
            hasArrows:
              configContentHub.videoGalleryLandscape?.heading?.hasArrows,
          }}
          strip={
            configContentHub.videoGalleryLandscape?.strip && {
              dividerVariant:
                configContentHub.videoGalleryLandscape.strip.dividerVariant,
              arrowSize:
                configContentHub.videoGalleryLandscape.strip.arrowSize ?? 30,
              arrowVariant:
                configContentHub.videoGalleryLandscape.strip.arrowVariant,
            }
          }
          cta={
            configContentHub.videoGalleryLandscape?.viewMore
              ? {
                  name:
                    configContentHub.videoGalleryLandscape.viewMore.text ||
                    "VIEW ALL VIDEOS",
                  url:
                    configContentHub.videoGalleryLandscape.viewMore.href ||
                    "/videos",
                  icon: configContentHub.videoGalleryLandscape.viewMore.icon,
                }
              : undefined
          }
          hasPagination={configContentHub.videoGalleryLandscape?.hasPagination}
          hasStripLabel={configContentHub.videoGalleryLandscape?.hasStripLabel}
          arrowSize={configContentHub.videoGalleryLandscape?.arrowSize}
          mobileLoopingArrowsBelow={{
            showArrows:
              configContentHub.videoGalleryLandscape?.spotLight
                ?.mobileLoopingArrowsBelow || false,
            leftIcon: <Arrow size={22} direction="left" />,
            rightIcon: <Arrow size={22} direction="right" />,
          }}
          showArrowsOnMobile={
            configContentHub.videoGalleryLandscape?.spotLight?.showArrowOnMobile
          }
        />
      </div>
    </div>
  );
}
